import * as React from "react"
import { useEffect} from "react"
import { Canvas} from 'react-three-fiber'
import {OrbitControls} from '@react-three/drei'
import create from 'zustand'
import '../styles/global.css'

import Scene from '../components/Scene'

import Text from '../components/Text'


const useStore = create(set => ({
  userplay: '',
  userPlayRock: () => { set(state => ({ userplay: 'rock'}))},
  userPlayPaper: () => set(state => ({ userplay: 'paper'})),
  userPlayScissors: () => set(state => ({ userplay: 'scissors'})),
  gameReset: ()=> set(state => ({userplay: ''})),
}))


const useStoreAI = create(set => ({
  aiplay: '',
  aiReset: ()=> set(state => ({aiplay: ''})),
  aiPlay: () => { 
    let playwhat = Math.floor(Math.random() * 100)%3
    switch(playwhat){
      case 0 :
        set(state => ({ aiplay: 'rock'}))
        break
      case 1 : 
        set(state => ({ aiplay: 'paper'}))
        break
      case 2 :  
        set(state => ({ aiplay: 'scissors'}))
        break
    }
  },
  
}))

// markup
const IndexPage = () => {




  return (
    <main>
      <div className="container">
        <Canvas camera={{fov : 50}}>
          <color attach="background" args={'#6CB0E7'}/>
          <ambientLight intensity={1.0}/>
          <pointLight position={[3, 3, 3] } intensity={1.5} castShadow/>
          <React.Suspense fallback={null}>
            <Scene useStore={useStoreAI}/>

          </React.Suspense>
       

          <OrbitControls enablePan={false} enableZoom={false}/>
       

        </Canvas>
      </div>
      <Text useStore={useStore} useStoreAI={useStoreAI}/>
      
    </main>
  )
}

export default IndexPage
